import React from 'react';

const FlagAU = ({ ...props }) => {
    return (
        <svg
            width="16"
            height="12"
            viewBox="0 0 16 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_4601_2055)">
                <mask
                    id="mask0_4601_2055"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="16"
                    height="12"
                >
                    <path d="M16 0H0V12H16V0Z" fill="white" />
                </mask>
                <g mask="url(#mask0_4601_2055)">
                    <path d="M16 0H0V12H16V0Z" fill="white" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 0H16V12H0V0Z"
                        fill="#E31D1C"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 1V2H16V1H0ZM0 3V4H16V3H0ZM0 6V5H16V6H0ZM0 7V8H16V7H0ZM0 10V9H16V10H0ZM0 12V11H16V12H0Z"
                        fill="#F7FCFF"
                    />
                    <path d="M9 0H0V7H9V0Z" fill="#2E42A5" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.04001 2.17L1.57001 1.8L1.98001 2.1H1.75001L2.22001 2.52L2.06001 3.1H1.81001L1.57001 2.56L1.36001 3.1H0.750012L1.22001 3.52L1.04001 4.18L1.57001 3.81L1.98001 4.11H1.75001L2.22001 4.53L2.06001 5.11H1.81001L1.57001 4.57L1.36001 5.11H0.750012L1.22001 5.53L1.04001 6.19L1.57001 5.82L2.08001 6.19L1.92001 5.53L2.33001 5.11H2.14001L2.56001 4.81L2.97001 5.11H2.74001L3.21001 5.53L3.03001 6.19L3.56001 5.82L4.07001 6.19L3.91001 5.53L4.32001 5.11H4.13001L4.55001 4.81L4.96001 5.11H4.73001L5.20001 5.53L5.02001 6.19L5.55001 5.82L6.06001 6.19L5.90001 5.53L6.31001 5.11H6.12001L6.54001 4.81L6.95001 5.11H6.72001L7.19001 5.53L7.01001 6.19L7.54001 5.82L8.05001 6.19L7.89001 5.53L8.30001 5.11H7.78001L7.54001 4.57L7.33001 5.11H7.03001L6.89001 4.53L7.30001 4.11H7.11001L7.53001 3.81L8.04001 4.18L7.88001 3.52L8.29001 3.1H7.77001L7.53001 2.56L7.32001 3.1H7.02001L6.88001 2.52L7.29001 2.1H7.10001L7.52001 1.8L8.03001 2.17L7.87001 1.51L8.28001 1.09H7.76001L7.52001 0.549999L7.31001 1.09H6.70001L7.17001 1.51L7.01001 2.09H6.76001L6.52001 1.55L6.31001 2.09H6.01001L5.87001 1.51L6.28001 1.09H5.76001L5.52001 0.549999L5.31001 1.09H4.70001L5.17001 1.51L5.01001 2.09H4.76001L4.52001 1.55L4.31001 2.09H4.01001L3.87001 1.51L4.28001 1.09H3.76001L3.52001 0.549999L3.31001 1.09H2.70001L3.17001 1.51L3.01001 2.09H2.76001L2.52001 1.55L2.31001 2.09H2.01001L1.87001 1.51L2.28001 1.09H1.76001L1.52001 0.549999L1.31001 1.09H0.700012L1.17001 1.51L0.990012 2.17H1.04001ZM7.06001 4.1L7.22001 3.52L6.75001 3.1H6.98001L6.57001 2.8L6.15001 3.1H6.34001L5.93001 3.52L6.07001 4.1H6.37001L6.58001 3.56L6.82001 4.1H7.07001H7.06001ZM5.98001 4.1L5.57001 3.8L5.15001 4.1H5.34001L4.93001 4.52L5.07001 5.1H5.37001L5.58001 4.56L5.82001 5.1H6.07001L6.23001 4.52L5.76001 4.1H5.99001H5.98001ZM4.22001 4.52L4.06001 5.1H3.81001L3.57001 4.56L3.36001 5.1H3.06001L2.92001 4.52L3.33001 4.1H3.14001L3.56001 3.8L3.97001 4.1H3.74001L4.21001 4.52H4.22001ZM4.36001 4.1H4.06001L3.92001 3.52L4.33001 3.1H4.14001L4.56001 2.8L4.97001 3.1H4.74001L5.21001 3.52L5.05001 4.1H4.80001L4.56001 3.56L4.35001 4.1H4.36001ZM3.06001 4.1L3.22001 3.52L2.75001 3.1H2.98001L2.57001 2.8L2.15001 3.1H2.34001L1.93001 3.52L2.07001 4.1H2.37001L2.58001 3.56L2.82001 4.1H3.07001H3.06001ZM6.22001 2.52L6.06001 3.1H5.81001L5.57001 2.56L5.36001 3.1H5.06001L4.92001 2.52L5.33001 2.1H5.14001L5.56001 1.8L5.97001 2.1H5.74001L6.21001 2.52H6.22001ZM3.98001 2.1L3.57001 1.8L3.15001 2.1H3.34001L2.93001 2.52L3.07001 3.1H3.37001L3.58001 2.56L3.82001 3.1H4.07001L4.23001 2.52L3.76001 2.1H3.99001H3.98001Z"
                        fill="#F7FCFF"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_4601_2055">
                    <rect width="16" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default FlagAU;
